import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';

const Aiuda = () => {
  const [imagenes, setImagenes] = useState([]);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchInfoEmpresasa = async () => {
      try {
        const response = await fetch("https://ricardodiaztuasesorfinanciero.com/api/imagenes", {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${token}`
          }
        });
        const data = await response.json();
        setImagenes(data);
      } catch (error) {
        console.error("Error al obtener la información", error);
      }
    };

    fetchInfoEmpresasa();
  }, [token]);

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h2 style={styles.headerTitle}>📋 Panel de administración de citas</h2>
        <div style={styles.navButtons}>
          <button style={styles.button} onClick={() => navigate('/')}>🏠 Menú Principal</button>
          <button style={styles.button} onClick={() => navigate('/CitasClientes')}>📆 Citas Pendientes</button>
          <button style={styles.button} onClick={() => navigate('/citasdespues')}>👥 Citas Finalizadas</button>
          <button style={styles.button} onClick={() => navigate('/adminseguros')}>📃 Formularios</button>
          <button style={styles.button} onClick={() => navigate('/horariosadmin')}>🕒 Horarios</button>
          <button style={styles.button} onClick={() => navigate('/adminblog')}>📰 Blog</button>
          <button style={styles.buttonActivo} onClick={() => navigate('/aiuda')}>⚙️ Ayuda</button>

        </div>
      </div>

      <h3 style={styles.sectionTitle}>🗓️ Guía rápida del panel administrativo</h3>

      <div style={styles.guideContainer}>

        {/* Sección: Administración del Blog */}
        <div style={styles.card}>
          <h4 style={styles.subTitle}>📰 Administración del Blog</h4>
          <p>Primero selecciona el apartado de Blog en la barra de navegación del panel administrativo.</p>
          <p>Cuando lo selecciones, verás todos los posts activos. Cada uno puede ser editado o eliminado con los botones disponibles.</p>
          <p>Haz clic en "Crear Post" para redactar una nueva entrada. Debes llenar obligatoriamente el título y contenido. Puedes agregar hasta 3 imágenes (opcionales).</p>
          {imagenes[2] && <img src={imagenes[2].imagen} alt="Blog" style={styles.image} />}
          {imagenes[3] && <img src={imagenes[3].imagen} alt="Blog" style={styles.image} />}
        </div>

        {/* Sección: Cambiar el horario de las citas */}
        <div style={styles.card}>
          <h4 style={styles.subTitle}>🕒 Cambiar el horario de las citas</h4>
          <p>Selecciona "Horarios" en el panel administrativo. Verás una lista con las horas disponibles para agendar citas.</p>
          <p>Desde ahí puedes seleccionar una fecha y visualizar el estado de cada hora (libre, ocupada o bloqueada).</p>
          <p>Cada hora tiene botones para:</p>
          <ul>
            <li><strong>Liberar:</strong> Disponible solo si está bloqueada o ocupada (por administración).</li>
            <li><strong>Bloquear:</strong> Impide que los usuarios agenden esa hora.</li>
            <li><strong>Ocupado:</strong> Marca la hora como no disponible por parte de administración.</li>
          </ul>
          <p>Desde "Editar Horas" puedes agregar o quitar horas del sistema. Guarda los cambios o cancélalos según lo necesites.</p>
          {imagenes[4] && <img src={imagenes[4].imagen} alt="Horarios" style={styles.image} />}
          {imagenes[5] && <img src={imagenes[5].imagen} alt="Horarios" style={styles.image} />}
        </div>

        {/* Sección: Pantalla de Citas Pendientes */}
        <div style={styles.card}>
          <h4 style={styles.subTitle}>📆 Pantalla de Citas Pendientes</h4>
          <p>Se muestran todas las citas agendadas para hoy o fechas futuras.</p>
          <p>Puedes:</p>
          <ul>
            <li><strong>Editar:</strong> Modifica los campos y guarda los cambios.</li>
            <li><strong>Eliminar:</strong> Borra la cita y libera la hora correspondiente.</li>
            <li><strong>Completar:</strong> Mueve la cita a la sección de citas finalizadas.</li>
          </ul>
        </div>

        {/* Sección: Pantalla de Citas Finalizadas */}
        <div style={styles.card}>
          <h4 style={styles.subTitle}>✅ Pantalla de Citas Finalizadas</h4>
          <p>Se muestran las citas que ya se llevaron a cabo.</p>
          <p>Puedes agregar notas para seguimiento. Una vez concluida completamente la atención, puedes eliminar la cita para archivar.</p>
        </div>

        {/* Sección: Formularios de Seguros */}
        <div style={styles.card}>
          <h4 style={styles.subTitle}>📃 Formularios de Seguros</h4>
          <p>En esta sección puedes filtrar por tipo de seguro.</p>
          <p>Cada formulario incluye un espacio para agregar notas y un botón para eliminar cuando ya no se necesite.</p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: '40px 20px',
    fontFamily: 'Segoe UI, sans-serif',
    backgroundColor: '#f4f6f9',
    minHeight: '100vh',
  },
  header: {
    backgroundColor: '#102a43',
    color: 'white',
    padding: '20px',
    borderRadius: '12px',
    marginBottom: '30px',
    textAlign: 'center'
  },
  headerTitle: {
    fontSize: '24px',
    fontWeight: 'bold',
    marginBottom: '10px'
  },
  navButtons: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '10px'
  },
  button: {
    backgroundColor: '#334e68',
    color: 'white',
    padding: '10px 18px',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '0.95rem'
  },
  buttonActivo: {
    backgroundColor: '#334e68',
    color: 'white',
    padding: '10px 18px',
    border: '2px #334e68',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '0.95rem'
  },
  sectionTitle: {
    fontSize: '26px',
    color: '#102a43',
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: '30px'
  },
  guideContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(330px, 1fr))',
    gap: '25px'
  },
  card: {
    backgroundColor: '#ffffff',
    border: '1px solid #d9e2ec',
    borderRadius: '12px',
    padding: '20px',
    boxShadow: '0 6px 18px rgba(0,0,0,0.06)',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  },
  subTitle: {
    fontSize: '18px',
    color: '#334e68',
    fontWeight: 'bold',
    marginBottom: '10px'
  },
  image: {
    maxWidth: '100%',
    borderRadius: '8px',
    border: '1px solid #ccc'
  }
};

export default Aiuda;
